import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getSummarizeWrittenText = (params) => {
	var url = ApiRouters.SUMMARIZEWRITTENTEXT;
	return api.get(url, { params });
};

export const getSummarizeWrittenTextDetail = (id, params) => {
	var url = `${ApiRouters.SUMMARIZEWRITTENTEXT}/${id}`;
	return api.get(url, { params });
};

export const createQuesSummarizeWrittenText = (body) => {
	var url = ApiRouters.SUMMARIZEWRITTENTEXT;
	return api.post(url, body);
};

export const updateSummarizeWrittenTextDetail = (body) => {
	var url = `${ApiRouters.SUMMARIZEWRITTENTEXT}/${body.id}`;
	return api.put(url, body);
};

export const deleteSummarizeWrittenText = (id) => {
	var url = `${ApiRouters.SUMMARIZEWRITTENTEXT}/${id}`;
	return api.delete(url);
};
